export interface IPrescriptionData {
    od_sph: number | null | string;
    od_cyl: number | null | string;
    os_sph: number | null | string;
    os_cyl: number | null | string;
    birth_year?: number | null | string;
    add?: number | null | string;
    image_file_url?: string | null;
}
export interface ILensPrescription {
    prescription: Partial<IPrescriptionData>;
    rx: string;
    attachment: string;
    showEdit: boolean;
    isoldThan40: boolean;
    isAddRecommend: boolean;
    isTypeRecommend: boolean;
}

export type State = ILensPrescription;

export type ILensPrescriptionAction = State & Action;

export type Action = {
    getPrescription: (
        value: Partial<IPrescriptionData>,
        rx: string,
        attachment: string,
        lens?: number,
    ) => void;
    initPrescription: () => void;
    showEditFunc: () => void;
};

export const initialState: State = {
    prescription: {
        od_sph: null,
        od_cyl: null,
        os_sph: null,
        os_cyl: null,
        birth_year: null,
        add: null,
        image_file_url: "",
    },
    rx: "",
    attachment: "",
    showEdit: true,
    isoldThan40: false,
    isAddRecommend: false,
    isTypeRecommend: false,
};
